var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.tableDate,"border":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }